module.exports = __webpack_public_path__ + "img/sternquell-logo.29e8e907.png";